<template>
  <v-navigation-drawer
    id="cadastro-drawer"
    v-model="globalStore.drawer.show"
    color="grey-lighten-4"
    temporary
    :right="globalStore.drawer.right"
    :width="globalStore.drawer.width"
    app fixed
  >
    <component :is="component"></component>

    <template v-slot:prepend>
      <slot name="prepend"></slot>
    </template>
  </v-navigation-drawer>
</template>

<script setup>
import { shallowRef, inject, watch, toRaw } from 'vue';
import { useGlobalStore } from '@/app/store/pinia/global';

const globalStore = useGlobalStore();
const component = shallowRef();

watch(() => globalStore.drawer.component, (value) => {
  component.value = toRaw(value);
});

// const disabledMouseScroll = (event) => {
//   event.preventDefault(); // Bloqueia a ação padrão do botão do scroll
// };

const scrollTop = () => {
  document.querySelector('#cadastro-drawer > .v-navigation-drawer__content').scrollTop = 0;
};

watch(() => globalStore.drawer.show, (value) => {
  if (value) {
    scrollTop();
  }
});

</script>

<style lang="scss" scoped>
// .v-navigation-drawer {
//   top: 0 !important;
//   min-height: 100dvh !important;
//   z-index: 1200 !important;
//   padding: 0;
// }
// .v-navigation-drawer__scrim {
//   opacity: 0.5 !important;
//   z-index: 1199 !important;
// }
</style>
